import Link from 'next/link'
import PropTypes from 'prop-types'
import { trackFor, getClientCountry } from 'lib/tracker/utils'

// Styles
import styles from './style.module.scss'

export const Item = ({ data, index, id }) => {
  const trackJobClick = () => {
    trackFor({
      gtm: {
        event: 'job_click',
        job_title: data.title,
        job_department: data.departments[0].name,
        job_location:
          data && !!data.offices[0] ? data.offices[0].location || data.offices[0].name : '',
        requisition_id: data && data.requisition_id,
        job_position: index + 1,
      },
      fbPixel: {
        event: 'ViewContent',
        event_name: 'CareerSiteViewContent',
        content_ids: data.id,
        content_name: data.title,
        content_type: 'product',
        country: getClientCountry(data.location?.name),
      },
      googleConversion: {
        conversion_label: '_-GTCIaKm8IDEP-ZgNAo',
        event_name: 'CareerSiteViewContent',
      },
      linkedinInsight: {
        conversion_id: '9193449',
      },
      tiktokPixel: {
        event: 'ViewContent',
        content_name: data.title,
        content_id: data.id,
        content_category: 'Vacancy',
      },
    })
  }

  return (
    <a
      target="_blank"
      rel="noreferrer noopener"
      className={styles.vacancy_item_wrapper}
      href={data.absolute_url}>
      <div onClick={trackJobClick}>
        <h3 className={styles.vacancy_title}>{data && data.title ? data.title : 'Title'}</h3>
        <p className={styles.vacancy_description}>
          <span className={styles.vacancy_location}>
            {data && !!data.offices[0]
              ? data.offices[0].location || data.offices[0].name
              : 'location'}
          </span>
          <span className={styles.vacancy_req_id}>{data ? data.requisition_id : ''}</span>
        </p>
      </div>
    </a>
  )
}

Item.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Item
